import { render } from "./QrGybDetail.vue?vue&type=template&id=3296c199&scoped=true"
import script from "./QrGybDetail.vue?vue&type=script&lang=js"
export * from "./QrGybDetail.vue?vue&type=script&lang=js"

import "./QrGybDetail.vue?vue&type=style&index=0&id=3296c199&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3296c199"]])

export default __exports__